import { createSlice } from "@reduxjs/toolkit";
import {
  createTaskAction,
  getCaseTasksAction,
  searchCasesAction,
  updateTaskAction,
  deleteDocumentAction,
  sendTaskEmailAction,
} from "../../actions/Task/caseTaskAction";

const initialState = {
  tasks: [],
  searchedCases: [],
  searchLoading: false,
  searchError: null,
  loading: false,
  createLoading: false,
  createSuccess: false,
  createError: null,
  updateLoading: false,
  updateSuccess: false,
  updateError: null,
  deleteDocLoading: false,
  deleteDocSuccess: false,
  deleteDocError: null,
  emailLoading: false,
  emailSuccess: false,
  emailError: null,
  hasFetched: false,
};

const caseTaskSlice = createSlice({
  name: "caseTask",
  initialState,
  reducers: {
    resetTaskFlags: (state) => {
      state.createSuccess = false;
      state.createError = null;
      state.updateSuccess = false;
      state.updateError = null;
      state.deleteDocSuccess = false;
      state.deleteDocError = null;
      state.emailSuccess = false;
      state.emailError = null;
    },
    clearTasks: (state) => {
      state.tasks = [];
      state.loading = true; // optional: show loader
    },
    clearSearchCases(state) {
      state.searchedCases = [];
      state.searchLoading = false;
      state.searchError = null;
    },
    updateLocalTasks: (state, action) => {
      const tasks = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      tasks.forEach((task) => {
        if (task && typeof task === "object" && task.TaskNumber) {
          const index = state.tasks.findIndex(
            (t) => t.TaskNumber === task.TaskNumber,
          );
          if (index !== -1) {
            state.tasks[index] = task;
          } else {
            state.tasks.push(task);
          }
        }
      });
    },
    removeLocalTask: (state, action) => {
      state.tasks = state.tasks.filter((t) => t.TaskNumber !== action.payload);
    },
    setHasFetched: (state) => {
      state.hasFetched = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchCasesAction.pending, (state) => {
        state.searchLoading = true;
        state.searchError = null;
      })
      .addCase(searchCasesAction.fulfilled, (state, action) => {
        state.searchLoading = false;
        state.searchedCases = action.payload || [];
      })
      .addCase(searchCasesAction.rejected, (state, action) => {
        state.searchLoading = false;
        state.searchError = action.payload;
      })
      .addCase(createTaskAction.pending, (state) => {
        state.createLoading = true;
        state.createSuccess = false;
        state.createError = null;
      })
      .addCase(createTaskAction.fulfilled, (state, action) => {
        console.log("createTaskAction payload:", action.payload);
        state.createLoading = false;
        state.createSuccess = true;
        const newTasks = Array.isArray(action.payload)
          ? action.payload
          : [action.payload];
        console.log("Number of new tasks:", newTasks.length);
        newTasks.forEach((task) => {
          if (task && typeof task === "object" && task.TaskNumber) {
            const index = state.tasks.findIndex(
              (t) => t.TaskNumber === task.TaskNumber,
            );
            if (index === -1) {
              state.tasks.push(task); // Append only if not present
            }
          }
        });
        state.hasFetched = false;
      })
      .addCase(createTaskAction.rejected, (state, action) => {
        state.createLoading = false;
        state.createError = action.payload;
      })
      .addCase(updateTaskAction.pending, (state) => {
        state.updateLoading = true;
        state.updateSuccess = false;
        state.updateError = null;
      })
      .addCase(updateTaskAction.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateSuccess = true;
        const updatedTask = action.payload;
        const index = state.tasks.findIndex(
          (t) => t.TaskNumber === updatedTask.TaskNumber,
        );
        if (index !== -1) {
          state.tasks[index] = updatedTask;
        }
        state.hasFetched = false;
      })
      .addCase(updateTaskAction.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = action.payload;
      })
      .addCase(getCaseTasksAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCaseTasksAction.fulfilled, (state, action) => {
        state.loading = false;
        const tasks = action.payload || [];
        const validTasks = tasks.filter(
          (t) => t && typeof t === "object" && t.TaskNumber,
        );
        const invalidTasks = tasks.filter(
          (t) => !(t && typeof t === "object" && t.TaskNumber),
        );
        if (invalidTasks.length > 0) {
          console.warn("Invalid tasks detected:", invalidTasks);
        }
        state.tasks = validTasks;
        state.hasFetched = true;
      })
      .addCase(getCaseTasksAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.hasFetched = true;
      })
      .addCase(deleteDocumentAction.pending, (state) => {
        state.deleteDocLoading = true;
        state.deleteDocSuccess = false;
        state.deleteDocError = null;
      })
      .addCase(deleteDocumentAction.fulfilled, (state) => {
        state.deleteDocLoading = false;
        state.deleteDocSuccess = true;
      })
      .addCase(deleteDocumentAction.rejected, (state, action) => {
        state.deleteDocLoading = false;
        state.deleteDocError = action.payload;
      })
      .addCase(sendTaskEmailAction.pending, (state) => {
        state.emailLoading = true;
        state.emailSuccess = false;
        state.emailError = null;
      })
      .addCase(sendTaskEmailAction.fulfilled, (state) => {
        state.emailLoading = false;
        state.emailSuccess = true;
      })
      .addCase(sendTaskEmailAction.rejected, (state, action) => {
        state.emailLoading = false;
        state.emailError = action.payload;
      });
  },
});

export const {
  clearTasks,
  resetTaskFlags,
  clearSearchCases,
  updateLocalTasks,
  removeLocalTask,
  setHasFetched,
} = caseTaskSlice.actions;
export default caseTaskSlice.reducer;
